import { WelcomeHeader } from "./components/WelcomeHeader";
import { KeyMetrics } from "./components/KeyMetrics";
import { PendingActions } from "./components/PendingActions";
import { RecentEnquiries } from "./components/RecentEnquiries";

const SellerDashboardPage = () => {
  return (
    <div className="min-h-screen bg-gray-50/50">
      <div className="px-4 sm:px-6 lg:px-8 max-w-[1600px] mx-auto py-5 space-y-5">
        <WelcomeHeader />

        <section className="space-y-3">
          <h2 className="text-xs font-semibold uppercase tracking-wider text-gray-500">
            Overview
          </h2>
          <KeyMetrics />
        </section>

        <section className="grid grid-cols-1 xl:grid-cols-2 gap-5">
          <RecentEnquiries />
          <PendingActions />
        </section>
      </div>
    </div>
  );
};

export default SellerDashboardPage;
